import { useState } from 'react';
import { DialogAction } from '../../../function/useModal';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    imageTagMuiDialogPaperWidthSm: {
      maxWidth: '100%',
    },
  })
);

type ImageDialogProps = {
  imagePath: string;
  imageName?: string;
  imageWidht: string;
  imageHeigth: string;
  dialog: DialogAction<ImageDialogResponse>;
  title: string;
};

export type ImageDialogResponse = {};

const ImageDialog: React.FC<ImageDialogProps> = (props: ImageDialogProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const classes = useStyles();
  return (
    <>
      <Dialog
        classes={{ paperWidthSm: classes.imageTagMuiDialogPaperWidthSm }}
        open={isOpen}
        onEntered={(e) => {}}
        onExited={(e) => {
          props.dialog.apply({});
        }}
      >
        <DialogTitle>{t('ImageDialog.三次元グラフ', '三次元グラフ')}</DialogTitle>
        <DialogContent>
          <div>{props.title}</div>
          <img src={props.imagePath} alt={props.imageName ?? ''} width={props.imageWidht} height={props.imageHeigth} />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" disableElevation onClick={() => setIsOpen(false)}>
            {t('ImageDialog.閉じる', '閉じる')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ImageDialog;
